import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FaBars, FaTimes } from 'react-icons/fa'
import { WiDaySnowThunderstorm } from "react-icons/wi";
import { VscAccount } from 'react-icons/vsc'
import { Button } from './Button';
import './Navbar.css';
import { IconContext } from 'react-icons/lib';


export default function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);


    const handleClick = () => {
        setClick(!click)
    }

    const closeMobileMenu = () => {
        setClick(false)
    }

    const showButton = () => {
        if (window.innerWidth <= 960) {
            setButton(false)
        } else {
            setButton(true)
        }
    }

    useEffect(() => {
        showButton();
    }, []);

    window.addEventListener('resize', showButton);

    return (
        <>
        <IconContext.Provider value={{ color: '#fff'}}>
            
            <div className="navbar">
                <div className="navbar-container container">
                    <Link to='/' className="navbar-logo" onClick={closeMobileMenu}>
                        <WiDaySnowThunderstorm className="navbar-icon" />
                        Wx Hub
                    </Link>
                    <div className="menu-icon" onClick={handleClick} >
                       {click ? <FaTimes /> : <FaBars />}
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        {/* <li className='nav-item'>
                            <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                                Start
                            </Link>
                        </li> */}
                        <li className='nav-item'>
                            <Link to='/test' className='nav-links' onClick={closeMobileMenu}>
                                TEST
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/aerodromes' className='nav-links' onClick={closeMobileMenu}>
                                Lotniska
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/metar-taf' className='nav-links' onClick={closeMobileMenu}>
                                Depesze
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/msd' className='nav-links' onClick={closeMobileMenu}>
                                MSD
                            </Link>
                        </li>
                        <li className='nav-btn'>
                            {button ? (
                                <Link to='/sign-up' className='btn-link'>
                                    <Button buttonStyle='btn--outline'>
                                    {/* <VscAccount /> */}
                                    Konto
                                    </Button>
                                </Link>
                            ) : (
                                <Link to='/sign-up' className='btn-link' onClick={closeMobileMenu}>
                                    <Button buttonStyle='btn--outline' buttonSize='btn--mobile'>
                                    {/* <VscAccount />  */}
                                    Konto
                                    </Button>
                                </Link>
                            )}
                        </li>
                    </ul>
                </div>
            </div>
        </IconContext.Provider>
        </>
    )
}